import React from "react"
import { graphql, PageProps } from "gatsby"
import Layout from "../components/layout"
import BlogItem from "../components/item-blog"
import Pagination from "../components/pagination"
import { BlogListQuery } from "./__generated__/BlogListQuery"

export default function blogList({ data, pageContext, location }: PageProps<BlogListQuery, {}>) {
    const blogItems = data.allMdx.edges.map(item => (
        <BlogItem data={item.node} key={item.node.id} />
    ))

    return (
        <Layout
            seo={{
                title: "Blog",
            }}
            location={location}
        >
            <div className="large-container">
                <header className="pt-20 pb-12 lg:pt-32 lg:pb-16 text-center">
                    <p className="eyebrow">Artykuły</p>
                    <h1 className="display-2 text-color-1 mt-5">Blog</h1>
                    <div className="rule-short mt-10 mx-auto"></div>
                </header>

                <div className="flex flex-wrap -mx-4">{blogItems}</div>

                <div className="pb-24 lg:pb-32">
                    <Pagination pageContext={pageContext} type="blog" />
                </div>
            </div>
        </Layout>
    )
}

export const query = graphql`
    query BlogListQuery($skip: Int!, $limit: Int!) {
        allMdx(
            filter: { fields: { sourceName: { eq: "blog" } } }
            sort: { fields: [frontmatter___date], order: DESC }
            limit: $limit
            skip: $skip
        ) {
            edges {
                node {
                    id
                    frontmatter {
                        title
                        description
                        date(formatString: "DD MMMM YYYY")
                        image {
                            publicURL
                            childImageSharp {
                                fluid(maxWidth: 1920) {
                                    srcSet
                                    ...GatsbyImageSharpFluid
                                }
                                id
                            }
                        }
                    }
                    fields {
                        slug
                    }
                }
            }
        }
    }
`
